import React, { useState, useEffect } from 'react';

/**
 * WhatsAppFAB — floating action button that opens a WhatsApp chat.
 * The phone number and pre-filled message are configured below and can
 * be swapped for real values by the estate.
 */
const PHONE = '393289462581';
const MESSAGE = 'Ciao Lempole, vorrei sapere di più su di voi.';

export default function WhatsAppFAB() {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    // Reveal after the hero section is scrolled past so it doesn't compete with the opening.
    const onScroll = () => setShown(window.scrollY > window.innerHeight * 0.4);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const href = `https://wa.me/${PHONE}?text=${encodeURIComponent(MESSAGE)}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`whatsapp-fab ${shown ? 'is-shown' : ''}`}
      aria-label="Contattaci su WhatsApp"
      data-testid="whatsapp-fab"
    >
      <svg viewBox="0 0 32 32" className="whatsapp-fab__icon" aria-hidden="true">
        <path
          fill="currentColor"
          d="M16.001 3.2c-7.07 0-12.8 5.73-12.8 12.8 0 2.26.593 4.47 1.72 6.418L3.2 28.8l6.573-1.72a12.75 12.75 0 006.228 1.588h.005c7.07 0 12.8-5.73 12.8-12.8 0-3.42-1.331-6.634-3.75-9.052A12.723 12.723 0 0016.001 3.2zm0 23.363h-.004a10.62 10.62 0 01-5.415-1.482l-.388-.23-4.02 1.052 1.073-3.918-.253-.402a10.57 10.57 0 01-1.62-5.63c0-5.867 4.77-10.638 10.63-10.638 2.84 0 5.51 1.108 7.517 3.116a10.56 10.56 0 013.114 7.522c-.002 5.867-4.773 10.61-10.634 10.61zm5.83-7.955c-.32-.16-1.893-.933-2.186-1.04-.293-.107-.507-.16-.72.16-.213.32-.827 1.04-1.014 1.253-.187.213-.373.24-.693.08-.32-.16-1.353-.5-2.578-1.591-.953-.85-1.596-1.9-1.783-2.22-.187-.32-.02-.494.14-.653.144-.144.32-.373.48-.56.16-.187.213-.32.32-.533.107-.213.053-.4-.027-.56-.08-.16-.72-1.734-.986-2.374-.26-.624-.524-.54-.72-.55l-.613-.011c-.213 0-.56.08-.853.4-.293.32-1.12 1.093-1.12 2.666 0 1.573 1.147 3.093 1.307 3.306.16.213 2.253 3.44 5.463 4.826.763.33 1.36.526 1.824.673.767.244 1.464.21 2.014.128.615-.093 1.893-.774 2.16-1.522.267-.746.267-1.386.187-1.52-.08-.133-.293-.213-.613-.373z"
        />
      </svg>
      <span className="whatsapp-fab__tip">Scrivici</span>
    </a>
  );
}
